module.exports = __webpack_public_path__ + "img/ewm.7ad941b1.png";